import C from "./index280.js";
import { resolveComponent as n, createElementBlock as r, openBlock as t, Fragment as c, createVNode as a, createElementVNode as i, withCtx as s, renderList as d, normalizeClass as h, normalizeStyle as v, createBlock as p, resolveDynamicComponent as g, toDisplayString as b, createTextVNode as m, TransitionGroup as w } from "vue";
import x from "./index231.js";
const T = { class: "flex gap-16 mb-16" }, $ = ["href", "title", "onClick"], B = { class: "pl-[12px] pr-8 h-52 border border-solid rounded-normal border-color-neutral-grey-20 flex items-center gap-16" }, L = ["title"], S = { class: "fixed -translate-x-1/2 bottom-32 left-1/2 z-overlay-canvas" };
function V(e, l, z, D, N, U) {
  const u = n("ms-copy"), f = n("cs-secondary-button"), k = n("cs-modal"), _ = n("cs-toast");
  return t(), r(c, null, [
    a(k, {
      headerText: "Teilen",
      visible: e.isVisible,
      "data-mod": e.$options.name,
      "onUpdate:visible": e.onUpdate
    }, {
      default: s(() => [
        i("div", T, [
          (t(!0), r(c, null, d(e.computedButtons, (o) => (t(), r("a", {
            key: o.url,
            href: o.url,
            style: v({
              backgroundColor: o.bgColor
            }),
            class: h([o.color, "flex items-center justify-center rounded-full h-50 w-50"]),
            target: "_blank",
            title: o.title,
            onClick: (y) => e.trackClick(o.trackingType, e.shareTrackingData)
          }, [
            (t(), p(g(o.icon), { class: "w-24 h-24" }))
          ], 14, $))), 128))
        ]),
        i("div", B, [
          i("div", {
            title: e.computedLinks.Copy,
            class: "overflow-hidden text-ellipsis text-text-l text-color-neutral-grey-60 whitespace-nowrap"
          }, b(e.computedLinks.Copy), 9, L),
          a(f, {
            class: "ml-auto shrink-0",
            isSmall: "",
            onClick: e.copyToClipBoard
          }, {
            icon: s(() => [
              a(u, { class: "w-24 h-24" })
            ]),
            default: s(() => [
              l[0] || (l[0] = m(" Link kopieren "))
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      _: 1
    }, 8, ["visible", "data-mod", "onUpdate:visible"]),
    i("div", S, [
      a(w, {
        name: "toast",
        tag: "ul",
        class: "flex flex-col-reverse gap-16"
      }, {
        default: s(() => [
          (t(!0), r(c, null, d(e.toasts, (o) => (t(), p(_, {
            key: o.id,
            onClose: (y) => e.onClose(o.id)
          }, {
            default: s(() => l[1] || (l[1] = [
              m(" Link in Zwischenablage kopiert ")
            ])),
            _: 2
          }, 1032, ["onClose"]))), 128))
        ]),
        _: 1
      })
    ])
  ], 64);
}
const G = /* @__PURE__ */ x(C, [["render", V]]);
export {
  G as default
};
